import { create } from "zustand";

type onOpenProps = {
  noteId: string;
  noteName: string;
  isPublic: boolean;
};

type ModalStore = {
  noteId?: string;
  noteName?: string;
  isPublic?: boolean;
  isOpen: boolean;
  onOpen: ({ noteId, noteName, isPublic }: onOpenProps) => void;
  onClose: () => void;
};

const useShareNoteModal = create<ModalStore>((set) => ({
  isOpen: false,
  onOpen: ({ noteId, noteName, isPublic }) =>
    set({
      isOpen: true,
      noteId,
      noteName,
      isPublic,
    }),
  onClose: () => set({ isOpen: false }),
}));

export default useShareNoteModal;
